import { Component } from '@angular/core';
import { CommonSharedModule } from '../common/shared.module';

@Component({
  selector: 'app-accessdenied',
  templateUrl: './access-denied.component.html',
  standalone: true,
  imports: [CommonSharedModule]
})
export class AccessDeniedComponent {}
